export const modalAnimations = {
  fade: 'fade'
}
